import {
  ManageRequestPath,
  ManageRequestsPaths,
} from './features/ManageRequestsPaths';
import { ApprovalPaths } from './features/ApprovalPaths';

const ESSFeatureRoutePath = {
  PROFILE: 'profile',
  PROFILE_DETAILS: 'details',
  ...ApprovalPaths,
  ...ManageRequestPath,
  ...ManageRequestsPaths,
};

export default ESSFeatureRoutePath;
